import { Box, styled, Typography } from "@mui/material";

const Root = styled(Box)(({ theme }) => ({
  position: "relative",
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 6,
  padding: theme.spacing(1.5, 1.5, 1),
  backgroundColor: "inherit",
}));

const Label = styled(Typography)(({ theme }) => ({
  position: "absolute",
  top: -8,
  left: 12,
  fontSize: "0.75rem",
  color: theme.palette.text.secondary,
  backgroundColor: "inherit",
  padding: "0 4px",
  lineHeight: 1,
  zIndex: 2,
}));

const Value = styled(Typography)(({ theme }) => ({
  fontSize: "0.9rem",
  fontWeight: 500,
  color: theme.palette.text.primary,
}));

export const CustomDisplayItem = ({ label, value }) => {
  return (
    <Root>
      <Label>{label}</Label>
      <Value>{value ?? "-"}</Value>
    </Root>
  );
};
